<template>
  <div class="locale-changer">
    <div class="swtich-title">{{ $t("header.language") }}:</div>
    <el-dropdown trigger="click">
      <span class="el-dropdown-link">
        {{ $i18n.locale }}
        <el-icon style="vertical-align: middle">
          <ArrowDown />
        </el-icon>
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item
            :disabled="lang === appLanguage"
            v-for="lang in availableLanguages"
            :key="lang"
            :value="lang"
            @click="appLanguage = lang"
          >
            {{ lang }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: "LocaleSwitcher",
  computed: {
    appLanguage: {
      get() {
        return this.$store.getters.getAppLanguage;
      },
      set(val) {
        localStorage.setItem("language", val);
        this.$store.commit("MUTATE_APP_LANGUAGE", val);
      },
    },
    availableLanguages() {
      return Object.keys(this.$i18n.messages);
    },
  },
};
</script>

<style lang="scss" scoped>
.locale-changer {
  display: flex;
  align-items: center;
  grid-gap: 5px;
  padding-right: 5px;
}
.swtich-title {
  display: block;
  font-size: 13px;
  line-height: 1.2em;
}
.el-dropdown {
  display: block;
  text-align: right;
  padding-top: 0;
  cursor: pointer;
  &:hover {
    .el-dropdown-link {
      color: $color-blue;
    }
  }
}
.el-dropdown-menu {
  &__item {
    padding: 0;
  }
  span {
    display: block;
    padding: 0 20px;
  }
}
@include breakpoint($mobile) {
  .swtich-title {
    text-align: right;
  }
}
</style>
